import React from "react";
import FaqList from "modules/non-protected-page/faq-list";

export const useFaqList = () => {
  const faqLists = [
    {
      question: "What happens when I run out of credits?",
      answer:
        "You can purchase additional credits at any time or wait for the next month to start fresh.",
    },
    {
      question: "Can i upgrade my plan at a later time?",
      answer: "Yes, you can upgrade your plan at any time.",
    },
    {
      question: "How do I cancel my subscription?",
      answer:
        "You can cancel your subscription at any time. Go to your account settings and click on the 'Cancel Subscription' button.",
    },
    {
      question: "Do unused credits carry over to the next month?",
      answer: "Currently unused credits don't carry over to the next month.",
    },
    {
      question: "What payment methods are accepted?",
      answer: "We accept all major credit cards.",
    },
    {
      question: "What is your refund policy?",
      answer: `Our service is accessible under the free plan, which you can use to evaluate your needs before opting for any paid features. We do not offer refunds for subscriptions.`,
    },
    {
      question: "How is billing calculated?",
      answer: "Billing is calculated on a monthly basis.",
    },
    {
      question: "Are there any hidden fees?",
      answer: "No, there are no hidden fees.",
    },
    {
      question:
        "Do you regularly update your platform and continually add advanced features?",
      answer:
        "Yes, we are committed to continuously improving our platform and adding advanced features to enhance user experience and effectiveness.",
    },
  ];

  return faqLists;
};
const Faq = React.memo(() => {
  const faqLists = useFaqList();
  return <FaqList faqLists={faqLists} />;
});

export default Faq;
